<template>

  <div id="creload" v-bind:class="{ relLoader: reloader }">
    <div class="large-12 medium-12 small-12 columns"><p></p>
        <h2>DOBITIE KREDITU</h2>
        <hr>
        <div class="text-center">
        <p class="payment-title">Vyberte svoju banku alebo platbu kartou</p>
        <div class="payment-section">
            <div class="payment-box" v-on:click="btnStyles('vubActive')"><img alt="" src="@/assets/img/vub.png" /><div v-bind:class="{ after: tIcon.vubActive }"></div></div>
            <div class="payment-box" v-on:click="btnStyles('tbActive')"><img alt="" src="@/assets/img/tb.png" /><div v-bind:class="{ after: tIcon.tbActive }"></div></div>
            <div class="payment-box" v-on:click="btnStyles('spActive')"><img alt="" src="@/assets/img/sp.png" /><div v-bind:class="{ after: tIcon.spActive }"></div></div>
        </div>
        <div class="payment-section_custom">
            <div class="payment-box_custom" v-on:click="btnStyles('cardActive')"><img alt="" src="@/assets/img/card.png" /><div v-bind:class="{ after: tIcon.cardActive }"></div></div>
        </div>
        </div>
        <div class="row">
            <div class="large-12 medium-12 small-12 columns xspace">         <hr/><span class="fet">Telefónne číslo </span><span class="right" style="padding-right:4px"><strong>{{ readMsisdn }}</strong></span> </div>
            <div class="large-12 medium-12 small-12 columns"> <span class="inline cre-detail" style="padding-left:0;">Spôsob platby</span> <span class="right" id="relCash" style="padding-right:4px">{{readRelBank}}</span> </div>
            <div class="large-12 medium-12 small-12 columns"> <span class="inline cre-detail" style="padding-left:0;">Zaplatíte</span> <span class="right" id="relCash" style="padding-right:4px">{{readRelVal}}</span> </div>
            <div class="large-12 medium-12 small-12 columns"> <span class="inline cre-detail" style="padding-left:0;">Bonusový kredit</span> <span class="right" id="relBonus" style="padding-right:4px">{{readActBonus}}</span> </div>
            <div class="large-12 medium-12 small-12 columns"> <span class="fet">Celkovo dobijeme</span>
            <h5 class="right" id="relCredit">{{readSum}}</h5> </div>
        </div>
        <div class="row">                    
        <div class="large-12 medium-12 small-12 columns">        
        <div  style="margin-left:5%;margin-right:5%">
        <div id="relSlider" class="range-slider round" data-slider>
            <span class="range-slider-handle" role="slider" tabindex="0"></span>
            <span class="range-slider-active-segment"></span>
            <input type="hidden">
        </div>                    
        </div>
        </div>                    
        </div><p></p>
        <a class="actions action" v-on:click="payRedir">Pokračovať</a>  
        <div class="color-magenta text-center" v-html="relemessg"></div>
        <p v-html="tpl('credit.reload')"></p>   <p>&nbsp;</p>
    </div>

  </div>
</template>

<script>
export default {
  name: 'creload',
  props: ['productdetail', 'tplData', 'states', 'filterBouquet'],
  data () {
    return {
      tpl: function(tpath) {
        const inObj = _.get(this.tplData, tpath); var res = null
        if (inObj) {res = inObj
        } else {
          res = tpath.toString()
        } return res
      },
      sliderData: {
        relVal: 12,
        actBonus: 0.42,
        slVal: 2,
        relSums: [7, 10, 12, 16, 25, 50],
        relBonus: [0, 0.2, 0.42, 0.8, 1.75, 7.5]
      },
      relemessg: '&nbsp;',
      readRelBank: '',
      rcTarget: 'card',
      reloader: true,
      tIcon: {
        vubActive: false,
        tbActive: false,
        spActive: false,
        cardActive: false
      }
    }
  },
  mounted: function() {

    var that = this
    var tSlVal = 2, slVal = 2, productName = 'tkarta'
    if ((((that.productdetail.product.productName).toLowerCase()).indexOf('ares') !== -1) ||  (((that.productdetail.product.productName).toLowerCase()).indexOf('juro') !== -1)) {
      productName = 'ares'      
    }
    that.$http.get(that.$store.state.reloadSrc + productName)
    .then(function (resp) {
      if (that.sliderData.relSums.length > 2 && resp.data.amount && resp.data.bonus) {
        if (!_.isEmpty(resp.data.amount) && _.isArray(resp.data.amount)) {
          that.sliderData.relSums = resp.data.amount
        }
        if (!_.isEmpty(resp.data.bonus) && _.isArray(resp.data.bonus)) {
          that.sliderData.relBonus = resp.data.bonus      
        }
      }
    })
    .catch(function(e){
      console.info(e.message)
    })
    .finally(function(){
      that.reloader = false
      $('[data-slider]').on('change.fndtn.slider', function(){
        slVal = $(this).attr('data-slider')
        if (tSlVal != slVal) {
            tSlVal = slVal
            that.sliderData.slVal = slVal
        }
      });
      $(document).foundation({slider: {
        start: 0,
        end: (that.sliderData.relSums.length - 1),
        initial: 2
      }})
      that.readRelBank = that.tplData.credit.bank.cardActive
    })    
  },
  created: function() {
    var that = this
    window.history.pushState(null, '')
    window.onpopstate = function(event) {
    window.history.replaceState(null, '')
    that.states.mainView = true
    that.states.creloadView = false
    }
  },
  computed: {
    readMsisdn: function() {
      if (String(this.productdetail.msisdn).length > 8) {
        return '0' + String(this.productdetail.msisdn).substring(3)
      }
      else {
        return ''
      }
    },
    readRelVal: function() {
      return parseFloat(this.sliderData.relSums[this.sliderData.slVal]).toFixed(2).toString().replace(/\./, ',') + ' €'
    },
    readActBonus: function() {
      if (parseFloat(this.sliderData.relBonus[this.sliderData.slVal]) > 0) {
        return parseFloat(this.sliderData.relBonus[this.sliderData.slVal]).toFixed(2).toString().replace(/\./, ',') + ' €'
      } else {
        return '0 €'
      }
    },
    readSum: function() {
      return (parseFloat(this.sliderData.relSums[this.sliderData.slVal]) + parseFloat(this.sliderData.relBonus[this.sliderData.slVal])).toFixed(2).toString().replace(/\./, ',') + ' €'
    }
  },
  methods: {
    
    payRedir: function() {
    var that = this
    var rcData = {}, rcUrl = "/pb/dobieasy/cardpay/prepaid"
    if (this.rcTarget == "card")  {
        rcData = { amount: parseFloat(this.sliderData.relSums[this.sliderData.slVal]).toString(), 
        msisdn: this.readMsisdn,
        rurl: "https://m.telekom.sk/platba/dakujeme",
        application: "3" }
    } else {
      rcData = {
        msisdne: this.readMsisdn,
        amount: parseFloat(this.sliderData.relSums[this.sliderData.slVal]).toString(),
        msisdni: this.readMsisdn,
        rurl: "http://m.telekom.sk/platba/dakujeme",
        sender: "m_care"
      }
      rcUrl = "/pb/dobieasy/" + this.rcTarget
    }
      this.relemessg = 'Spracovávam...'
      this.$http.post(rcUrl, rcData)
        .then(function (resp) {
          if (that.rcTarget == "card")  {
            if (resp.data.response == 'ok') {
              location.href = resp.data.msg;
            } else { 
              that.relemessg = resp.data.msg
            }
          } else {
            if (resp.data.status == 'OK') {
              location.href = resp.data.url;
            } else { 
              that.relemessg = resp.data.error
            }
          }
        })
        .catch(function(error){
          // that.states.mainView = true
          // that.states.creloadView = false
          that.relemessg = "<label class='color-magenta'>Došlo ku chybe pri presmerovaní na platobnú bránu.</label><p></p>"
        })
    },    
    btnStyles: function(t) {
      var that = this
      switch(t) {
        case "vubActive":  
          that.readRelBank = that.tpl("credit.bank." + t)
          that.rcTarget = "vub"
          break
        case "tbActive":
          that.readRelBank = that.tpl("credit.bank." + t)
          that.rcTarget = "taba"
          break
        case "spActive":
          that.readRelBank = that.tpl("credit.bank." + t)
          that.rcTarget = "slsp"
          break
        default:
          that.readRelBank = that.tpl("credit.bank.cardActive")
          that.rcTarget = "card"
          break
      }

      for (var b in that.tIcon) {
        if (b == t) {
          that.tIcon[b] = false
        } else {
          that.tIcon[b] = true
        }
      }
    }
  }
}
</script>

<style scoped>

.payment-box_custom {
  height: auto !important;
  width: 230px;
  border: 1px solid #d0d0d0;
  margin-bottom: 0.7rem;
  position: relative;
  padding: 10px; }

.payment-section_custom {
  height: auto !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.payment-box_custom img {
  width: 100%; }

.payment-section {
  max-width: 230px;
  display: inline-block; }

.payment-box {
  border: 1px solid #d0d0d0;
  width: 70px;
  height: 70px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  float: left; }

.payment-box img {
  width: 80%;
 }

.payment-box:nth-of-type(1), .payment-box:nth-of-type(2) {
  margin: 0 10px 3px 0; }

.payment-title {
  margin: 10px 0 0 0;
}  

.payment-box .after, .payment-box_custom .after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: block;
    background: rgba(255, 255, 255, 0.85);
    cursor: pointer;
    color: #fff;
}

.relLoader {
  pointer-events: none;
}

.xspace {
  margin: 0.7rem 0;
}
</style>
